import { Box } from '@cp/ds/src/components/box';
import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import Header from 'src/widgets/header';
import { UserAgreementContent } from './components/userAgreementContent';

const UserAgreement: React.FC<RouteConfigComponentProps> = () => {
  return (
    <Box>
      <Helmet>
        <title>Пользовательское соглашение - YouHelp.ru</title>
      </Helmet>

      <Header />

      <UserAgreementContent />
    </Box>
  );
};

export default UserAgreement;
